export default function($) {
  let postsSwiper = document.querySelector('.js-posts-slider');
  const postsSwiperParams = {
    slidesPerView: 1,
    pagination: {
      el: ".posts-swiper-pagination",
      clickable: true,
    },
    loop: false,
    on: {
      destroy: function() {
        $('.posts-swiper-pagination').hide();
      },
      init: function() {
        $('.posts-swiper-pagination').show();
      },
    },
  }

  swiperDisplay();

  $(window).resize(function() {
    swiperDisplay();
  })

  function swiperDisplay() {
    if( $(window).width() < 640 ) {
      if( $('.js-posts-slider').length > 0 && !postsSwiper.initialized ) {
        postsSwiper = new Swiper('.js-posts-slider', postsSwiperParams);
      };
    }
    else {
      if( $('.js-posts-slider').length > 0 && postsSwiper.initialized ) {
        postsSwiper.destroy(false,true);
        $('.js-posts-slider').find('.swiper-wrapper').removeAttr('style');
        return;
      } else {
        $('.posts-swiper-pagination').hide();
      };
    }
  }
}
